<template>
  <div id="editactive">
    <div class="rightContent">
      <div class="listBlock">
        <el-form :model="sForm">
          <el-form-item :label="'*'+$i18n.t('active_name')" :label-width="formLabelWidth">
            <el-input v-model="sForm.act_name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item :label="'*'+$i18n.t('active_time')" :label-width="formLabelWidth">
            <el-date-picker
              size="small"
              v-model="adateValue"
              value-format="yyyy-MM-dd"
              type="daterange"
              :range-separator="$i18n.t('to')"
              :start-placeholder="$i18n.t('start_time')"
              :end-placeholder="$i18n.t('end_time')"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="'*'+$i18n.t('active_short')" :label-width="formLabelWidth">
            <el-input rows="3" style="width: 6rem;" type="textarea" v-model="sForm.act_desc"></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom:0px;" :label="'*'+$i18n.t('prize_set')" :label-width="formLabelWidth">
            <el-table :data="plists" style="width: 7rem;border:1px solid #ccc;font-size: 12px;">
              <el-table-column prop="num" :label="$i18n.t('num')" width="60"></el-table-column>
              <el-table-column :label="$i18n.t('prize_image')" width="110">
                <template slot-scope="scope">
                  <img v-if="scope.row.prize_pic" :src="'/fileSvr/get/' + scope.row.prize_pic" style="width:0.6rem;height:0.45rem;" />
                  <img v-else src="../assets/img/xiexie.jpg" style="width:0.6rem;height:0.45rem;" />
                </template>
              </el-table-column>
              <el-table-column width="110" :label="$i18n.t('prize_name')">
				  <template slot-scope="scope">
					<div>{{changeKo(scope.row.prize_name)}}</div>
				  </template>
			  </el-table-column>
              <el-table-column prop="probability" width="100" :label="$i18n.t('award_percent')"></el-table-column>
              <el-table-column prop="total_num" width="100" :label="$i18n.t('award_count_short')">
                <template slot-scope="scope">
                  <div v-if="scope.row.notdefault">{{scope.row.total_num}}</div>
                  <div v-else>--</div>
                </template>
              </el-table-column>
              <el-table-column prop="total_num" width="110" :label="$i18n.t('award_count_leave')">
                <template slot-scope="scope">
                  <div v-if="scope.row.notdefault">{{scope.row.left_num}}</div>
                  <div v-else>--</div>
                </template>
              </el-table-column>
              <el-table-column :label="$i18n.t('prize_desc')">
                <template slot-scope="scope">
                  <div
                    style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:1.2rem;"
                  >{{changeKo(scope.row.prize_detail)}}</div>
                </template>
              </el-table-column>
              <el-table-column :label="$i18n.t('contral')">
                <template slot-scope="scope">
                  <el-button type="text" @click="addAward(scope.row)">{{$t("edit")}}</el-button>
                  <el-button
                    v-show="scope.row.notdefault"
                    type="text"
                    @click="delAward(scope.row.id)"
                  >{{$t("delete")}}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item style="margin-top:0px;" label :label-width="formLabelWidth">
            <el-button class="btn5" type="primary" @click="addAward(false)">{{$t("prize_add")}}</el-button>
            <span style="color:#57AEC9;margin-left:10px;">* {{$t("prize_tips")}}</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="padding-left: 1rem;">
          <el-button
            style="background-color:#999;border-color:#999;"
            class="btn3"
            type="primary"
            @click="active"
          >{{$t("normal_cancle")}}</el-button>
          <el-button class="btn3" type="primary" @click="subimtActive">{{$t("normal_sure")}}</el-button>
        </div>
      </div>
      <!-- <img
        style="position: absolute;top: 0.5rem;right: 2rem; width:2rem;"
        src="../assets/img/tipsimage.jpg?i=1.0"
      /> -->
    </div>
    <el-dialog :title="$i18n.t('prize_add_edi')" :visible.sync="dialogPrizeFormVisible" :close-on-click-modal="false" width="5rem">
      <el-form :model="pForm">
        <el-form-item style="margin-bottom: 0.01rem;" :label="$i18n.t('prize_name')" :label-width="formLabelWidth">
          <el-input v-model="pForm.prize_name" autocomplete="off"></el-input>
          <span style="color:#999;font-size:0.09rem;">*{{$t("prize_name_tips")}}</span>
        </el-form-item>
        <el-form-item style="margin-bottom: 0.03rem;" :label="$i18n.t('prize_image')" :label-width="formLabelWidth">
          <el-upload
            class="avatar-uploader"
            action="/skinMgrSrv/goods/upload"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <div class="imgblockForLogo" v-if="pForm.prize_pic">
              <img :src="'/fileSvr/get/' + pForm.prize_pic" class="avatar" />
            </div>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <span
            style="font-size:0.09rem;color:#999;margin-left:0.08rem;width:2.7rem;float:right;line-height:150%;margin-top:0.1rem;"
          >
            *{{$t("prize_image_tip1")}}
            <br />*{{$t("prize_image_tip2")}}
            <br />*{{$t("prize_image_tip3")}}
          </span>
        </el-form-item>
        <el-form-item :label="$i18n.t('award_percent')" :label-width="formLabelWidth">
          <el-input class="harf" v-model="pForm.probability" autocomplete="off"></el-input>
          <span style="font-size:0.09rem;color:#999;">% ({{$t("prize_image_limit_tips")}}{{checkAwardGailvLeftData}}%)</span>
        </el-form-item>
        <el-form-item v-show="pForm.notdefault" :label="$i18n.t('prize_count')" :label-width="formLabelWidth">
          <el-input class="harf" v-model="pForm.total_num" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$i18n.t('prize_desc')" :label-width="formLabelWidth">
          <el-input rows="6" style="width: 3rem;" type="textarea" v-model="pForm.prize_detail"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogPrizeFormVisible = false">{{$t("normal_cancle")}}</el-button>
        <el-button type="primary" @click="subimtPrize">{{$t("normal_sure")}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "editactive",
  data() {
    return {
      doing: false,
      code: "",
      plists: null,
      code: "",
      configType: 1,
      adateValue: "",
      dialogPrizeFormVisible: false,
      sForm: {
        id: "",
        act_name: "",
        act_desc: "",
        start_time: "",
        end_time: ""
      },
      pForm: {
        id: "",
        prize_id: "",
        award_level: "1",
        probability: "",
        total_num: "",
        prize_name: "",
        prize_pic: "",
        prize_detail: "",
        notdefault: true
      },
      formLabelWidth: "1rem",
      checkAwardGailvLeftData: 100
    };
  },
  computed: {},
  created() {
    this.resizedwindow();
	if(localStorage.locale !== 'zh'){
		this.formLabelWidth = '1.2rem'
	}
    this.configType = this.getConfigType();
    if (this.configType === 1) {
      //极简风格无设备
      this.code = -1;
    }
    if (localStorage.editActiveData !== "") {
      console.log('--------------');
      console.log(localStorage.editActiveData);
      let acdata = JSON.parse(localStorage.editActiveData);
      if(acdata.id){
        this.sForm.id = acdata.id;
        this.sForm.act_name = acdata.act_name;
        this.sForm.act_desc = acdata.act_desc;
        this.sForm.start_time = acdata.start_time;
        this.sForm.end_time = acdata.end_time;
        this.adateValue = [this.sForm.start_time+'', this.sForm.end_time+''];
      }
    }
    this.getPrizeList(this.sForm.id);
    
  },
  methods: {
	changeKo(val){
		if(localStorage.locale !== 'ko'){
			return val
		}
		if(val == '谢谢参与'){
			return this.$i18n.t('thinkyou')
		}
		if(val == '很遗憾没中奖'){
			return this.$i18n.t('sorry')
		}
	},
    handleAvatarSuccess(res, file) {
      if (res.code === 0) {
        this.pForm.prize_pic = res.imgUrl;
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPng = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 0.5;

      if (!isJPG && !isPng) {
        this.$message.error(this.$i18n.t('image_fix_tips'));
      }
      if (!isLt2M) {
        this.$message.error(this.$i18n.t('image_big_tips'));
      }
      return (isJPG || isPng) && isLt2M;
    },
    getPrizeList(id) {
      if (this.doing === true) {
        return false;
      }
      if (!id || id === "") {
        id = -1;
      }
      let dataLoadIng = this.openFullScreen()
      this.doing = true;
      let _this = this;
      let data = {};
      data.code = this.code;
      data.act_id = id;
      this.axios
        .post("/skinMgrSrv/active/prizeAndAwardlist", this.formData(data))
        .then(function(response) {
          _this.doing = false;
          if (response.data.code === 0) {
            _this.plists = response.data.list;
          }
          setTimeout(() => {
            dataLoadIng.close()
          }, 500);
        });
    },
    editActive(data) {
      this.aForm = data;
      this.aForm.status = data.status + "";
      this.adateValue = [this.aForm.start_time, this.aForm.end_time];
      this.dialogFormVisible = true;
    },
    statusActive(id, status) {
      if (this.doing === true) {
        return false;
      }
      this.doing = true;
      let _this = this;
      let data = this.aForm;
      data.code = { id: id, status: status };
      this.axios
        .post("/skinMgrSrv/active/save", this.formData(data))
        .then(function(response) {
          _this.doing = false;
          if (response.data.code === 0) {
            _this.getPrizeList();
          }
        });
    },
    setAwardName(level) {
      if (this.aForm.award_name == "") {
        this.aForm.award_name = this.awardlevel[level];
      }
    },
    addAward(data) {
      if (data) {
        this.pForm = data;
		this.pForm.prize_detail = this.changeKo(this.pForm.prize_detail)
		this.pForm.prize_name = this.changeKo(this.pForm.prize_name)
        this.dialogPrizeFormVisible = true;
        this.checkAwardGailvLeftData = this.checkAwardGailvLeft(this.pForm)
        return true;
      }
      let act_id = this.sForm.id;
      if (!act_id || act_id === "") {
        act_id = -1;
      }
      this.pForm = {
        id: "",
        act_id: act_id,
        prize_id: "",
        award_level: "1",
        probability: "",
        total_num: "",
        prize_name: "",
        prize_pic: "",
        prize_detail: "",
        notdefault: true
      };
      this.dialogPrizeFormVisible = true;
      this.checkAwardGailvLeftData = this.checkAwardGailvLeft(this.pForm)
    },
    delAward(id) {
      let data = {
        id: id,
        status: -10
      }
      let _this = this
      this.axios.post('/skinMgrSrv/active/awardsave', this.formData(data)).then(function (response) {
        if (response.data.code === 0) {
          _this.getPrizeList()
        }
      })
    },
    blength: function blength(str) {  
      let b = 0; 
      let le = str.length; 
      if(le) { 
        for(let i = 0; i < le; i ++) { 
          if(str.charCodeAt(i) > 255) { 
            b += 2;
          }else {
            b ++; 
          }
        }
        return b;
      } else {
        return 0;
      }
    },
    subimtPrize() {
      if (this.doing === true) {
        return false;
      }
      
      if(this.pForm.prize_name === ''){
        this.$message(this.$i18n.t('prize_name') + this.$i18n.t('normal_notnull'));
        return false;
      }
      let nameln = this.blength(this.pForm.prize_name);
      if(nameln > 12){
        this.$message(this.$i18n.t('prize_name_tips'));
        return false;
      }

      if(this.pForm.prize_detail === ''){
        this.$message(this.$i18n.t('prize_desc') + this.$i18n.t('normal_notnull'));
        return false;
      }
      if(this.pForm.prize_pic === ''){
        this.$message(this.$i18n.t('prize_image') + this.$i18n.t('normal_notnull'));
        return false;
      }
      if(this.pForm.total_num === ''){
        this.$message(this.$i18n.t('prize_count') + this.$i18n.t('normal_notnull'));
        return false;
      }
      if(this.pForm.probability === ''){
        this.$message(this.$i18n.t('award_percent') + this.$i18n.t('normal_notnull'));
        return false;
      }
      let check = this.checkAwardGailv(this.pForm);
      if (!check) {
        this.$message(this.$i18n.t('prize_percent_limit'));
        return false;
      }
      this.doing = true;
      let _this = this;
      let data = this.pForm;
      data.code = this.code;
      this.axios
        .post("/skinMgrSrv/active/prizesave", this.formData(data))
        .then(function(response) {
          _this.doing = false;
          if (response.data.code === 0) {
            _this.$message(_this.$i18n.t('support_success'));
            _this.dialogPrizeFormVisible = false;
          }else{
            if(response.data.msg){
              _this.$message(response.data.msg);
            }else{
              _this.$message(this.$i18n.t('contral') + this.$i18n.t('fail'));
            }
          }
          _this.getPrizeList(_this.sForm.id);
        });
    },
    checkAwardGailv(fdata) {
      let p = 0;
      let lh = this.plists.length ? this.plists.length : 0;
      for (let i = 0; i < lh; i++) {
        let percent = this.plists[i].probability;
        if (fdata.id && this.plists[i].id === fdata.id) {
          percent = fdata.probability;
        }
        p += parseFloat(percent);
      }
      if (!fdata.id || fdata.id === "") {
        p += parseFloat(fdata.probability);
      }
      if (p > 100) {
        return false;
      }
      return true;
    },
    checkAwardGailvLeft(fdata) {
      let p = 0;
      let lh = this.plists.length ? this.plists.length : 0;
      for (let i = 0; i < lh; i++) {
        let percent = this.plists[i].probability;
        p += parseFloat(percent);
        if (fdata.id && this.plists[i].id === fdata.id) {
          p -= parseFloat(fdata.probability);
        }
      }
      console.log(p);
      return 100-p;
    },
    subimtActive() {
      if (this.doing === true) {
        return false;
      }
      if (this.sForm.act_name === "") {
        this.$message(this.$i18n.t('prize_name') + this.$i18n.t('normal_notnull'));
        return false;
      }
      if (this.sForm.act_desc === "") {
        this.$message(this.$i18n.t('prize_desc') + this.$i18n.t('normal_notnull'));
        return false;
      }
      if (this.adateValue === "") {
        this.$message(this.$i18n.t('active_time') + this.$i18n.t('normal_notnull'));
        return false;
      }
      let lh = this.plists.length ? this.plists.length : 0;
      if(lh > 8 || lh < 2){
        this.$message(this.$i18n.t('prize_tips'));
        return false;
      }
      this.doing = true;
      let _this = this;
      let data = this.sForm;
      data.code = this.code;
      data.start_time = this.adateValue[0];
      data.end_time = this.adateValue[1];
      this.axios
        .post("/skinMgrSrv/active/save", this.formData(data))
        .then(function(response) {
          _this.doing = false;
          if (response.data.code === 0) {
            _this.$message(_this.$i18n.t('support_success'));
            _this.active();
          }
        });
    },
    active() {
      this.$router.push({ path: "/skinmgr/lottory" });
    }
  }
};
</script>
<style  lang="scss">
#editactive {
  .tabs-container {
    .el-card__header {
      padding: 0.0833rem 0.1667rem !important;
    }
    .el-card {
      cursor: pointer;
    }
    .el-card:hover {
      border: $blue 1px solid;
    }
  }
  .el-input__inner {
    width: 2.5rem;
  }
  .harf,
  .harf .el-input__inner {
    width: 1.5rem;
  }
  .codeshearch,
  .codeshearch .el-input__inner {
    width: 2.45rem;
  }
  .codeshearch {
    margin-left: 0.05rem;
    margin-right: 0.02rem;
  }
  .avatar-uploader,
  .el-upload,
  .el-upload--text {
    width: 0.8rem;
    height: 0.6rem;
    display: inline-block;
  }
  .avatar-uploader-icon {
    border: 1px solid #ccc;
  }
  .el-table td,
  .el-table th {
    padding: 5px;
  }
  .el-table th {
    background-color: #e2e2e2;
    padding: 3px;
    color: #000;
  }
}
</style>
<style scoped lang="scss">
#editactive {
  box-sizing: border-box;
  min-height: 7rem;
  .rightContent {
    width: calc(100% - 0.32rem);
    height: calc(100% - 0.1667rem);
    display: inline-block;
    background-color: #fff;
    margin-left: 0.1667rem;
    margin-top: 0.1667rem;
    border-radius: 0.05rem;
    min-height: 7rem;
    .tableheader {
      margin: 0.16rem;
    }
    p.title {
      height: 0.4167rem;
      line-height: 0.4167rem;
      font-size: 0.12rem;
      color: #000;
    }
    .btn2,
    .btn3 {
      padding: 0.0867rem 0.2833rem;
      background-color: #57AEC9;
      border: 1px solid #57AEC9;
    }
    .btn5 {
      padding: 0.0567rem 0.1233rem;
      background-color: #fff;
      border: 1px solid #57AEC9;
      color: #57AEC9;
    }
    .listBlock {
      margin: 0.3rem 0.08rem;
    }
    .warncolor {
      color: red;
    }
    .btndel {
      margin-left: 0.1rem;
      height: 0.28rem;
      position: relative;
      top: 0.05rem;
    }
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 0.8rem;
    height: 0.6rem;
    margin-left: 1rem;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    color: #8c939d;
    width: 0.8rem;
    height: 0.6rem;
    text-align: center;
    line-height: 0.6rem;
  }
  .imgblockForLogo {
    width: 0.8rem;
    height: 0.6rem;
    display: inline-block;
    border: 1px solid #ccc;
  }
  .avatar {
    width: 0.8rem;
    height: 0.6rem;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/sell/editactive.vue